import { FormControl, Autocomplete, TextField, Grid } from '@mui/material';
import { DocumentData } from 'firebase/firestore';
import { useState, useEffect } from 'react';

interface PersonaSelectorProps {
  clientList: string[];
  selectedClient: DocumentData | null;
  onClientChange: (value: string) => void;
  mode: 'hp' | 'client';
}

function PersonaSelector({
  clientList,
  selectedClient,
  onClientChange,
  mode,
}: PersonaSelectorProps) {
  const [selectedClientName, setSelectedClientName] = useState<string | null>(
    null
  );
  useEffect(() => {
    if (selectedClient) {
      const selectedClientName =
        mode === 'client'
          ? `${selectedClient.fname} ${selectedClient.lname} (${selectedClient.email})`
          : selectedClient.name;
      setSelectedClientName(selectedClientName);
    }
  }, [mode, selectedClient]);

  return (
    <Grid item sm={8}>
      <FormControl fullWidth>
        <Autocomplete
          options={clientList}
          value={selectedClientName || null}
          onChange={(_e, value) => onClientChange(value as string)}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              fullWidth
              name="client"
              label={
                mode === 'client'
                  ? 'Select Client'
                  : 'Select Healthcare Provider'
              }
              variant="outlined"
            />
          )}
        />
      </FormControl>
    </Grid>
  );
}

export default PersonaSelector;
